import * as styles from "./SectionContactDetails.module.scss";

import React from "react";
import { Button, SocialMediaIcons } from "../../../components/common";
import { Envelope, Location, Phone } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ContactDetailsProps {
	ctaOne?: { label: string; url: string };
	ctaTwo?: { label: string; url: string };
	email: string;
	facebookUrl: string;
	instagramUrl: string;
	linkedInUrl: string;
	location: {
		addressLineOne: string;
		city: string;
		companyName: string;
		googleMaps: string;
		postcode: string;
	};
	openingTimes: string;
	phoneNumber: string;
	xUrl: string;
}

export interface SectionContactDetailsProps extends ContactDetailsProps {
	heading?: string;
	jumpLinksTitle?: string;
}

export const getSectionContactDetailsProps = (
	data?: Queries.SectionDataFragment,
	heading?: string,
	jumpLinksTitle?: string,
): ContactDetailsProps => ({
	...JSON.parse(data.field_json_config),
	heading,
	jumpLinksTitle,
});
export const SectionContactDetails: React.FC<SectionContactDetailsProps> = ({
	heading,
	ctaOne,
	ctaTwo,
	email,
	facebookUrl,
	instagramUrl,
	linkedInUrl,
	location,
	openingTimes,
	phoneNumber,
	xUrl,
	jumpLinksTitle,
}) => {
	return (
		<WrappedSection
			sectionName={"SectionContactDetails"}
			sectionColour={Colours.SANDY_FUR}
		>
			<div className={styles.innerwrapper} />
			<div className={styles.heading}>
				{jumpLinksTitle ? (
					<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
						{heading}
					</h2>
				) : (
					<h2 className={styles.title}>{heading}</h2>
				)}
			</div>
			<div className={styles.detailswrapper}>
				{!!location &&
					location.companyName &&
					location.addressLineOne &&
					location.city &&
					location.postcode && (
						<div className={styles.detailsection}>
							<h3 className={styles.detailstitle}>Location</h3>
							<div className={styles.detail}>
								<div className={styles.icon}>
									<Location height={"24px"} width={"24px"} />
								</div>
								<div className={styles.address}>
									<address>
										{!!location.companyName && (
											<>
												{location.companyName}
												<br />
											</>
										)}
										{!!location.addressLineOne && (
											<>
												{location.addressLineOne}
												<br />
											</>
										)}
										{!!location.city && (
											<>
												{location.city}
												<br />
											</>
										)}
										{!!location.postcode && location.postcode}
									</address>
									{location.googleMaps && (
										<a href={location.googleMaps}>{"Google Maps"}</a>
									)}
								</div>
							</div>
						</div>
					)}

				{(phoneNumber || openingTimes || email) && (
					<div className={styles.detailsection}>
						<h3 className={styles.detailstitle}>{"Contact"}</h3>
						{phoneNumber && openingTimes && (
							<div className={styles.detail}>
								<div className={styles.icon}>
									<Phone height="24px" width="24px" />
								</div>
								<div className={styles.link}>
									{phoneNumber && (
										<a href={`tel:${phoneNumber?.replace(/\s/g, "")}`}>
											{phoneNumber}
										</a>
									)}
									{openingTimes && (
										<p className={styles.openingtimes}>{openingTimes}</p>
									)}
								</div>
							</div>
						)}
						{email && (
							<div className={styles.detail}>
								<div className={styles.icon}>
									<Envelope height="24px" width="24px" />
								</div>
								<a href={`mailto:${email}`}>{email}</a>
							</div>
						)}
					</div>
				)}
				{(xUrl || facebookUrl || instagramUrl || linkedInUrl) && (
					<div className={styles.detailsection}>
						<h3 className={styles.detailstitle}>{"Follow us"}</h3>
						<SocialMediaIcons
							invert={true}
							iconSize={"35px"}
							xUrl={xUrl}
							facebookUrl={facebookUrl}
							instagramUrl={instagramUrl}
							linkedInUrl={linkedInUrl}
						/>
					</div>
				)}
			</div>
			<div className={styles.buttoncontainer}>
				{ctaOne && (
					<Button variant={"tertiary"} url={ctaOne.url} fullWidth={true}>
						{ctaOne.label}
					</Button>
				)}
				{ctaTwo && (
					<Button variant={"secondary"} url={ctaTwo.url} fullWidth={true}>
						{ctaTwo.label}
					</Button>
				)}
			</div>
		</WrappedSection>
	);
};

export default SectionContactDetails;
